import { FormattedNumber } from 'react-intl';
import PropTypes from 'prop-types';
import style from 'ui-components/components/tree-navigation/tree-navigation.module.less';

export const TreeItemCount = ({ count = 0, onClick }) => {
  if (count === 0) {
    return null;
  }
  return (
    <div className={style['count-wrapper']} onClick={onClick}>
      <div className={style.count}>
        <FormattedNumber value={count} />
      </div>
    </div>
  );
};

TreeItemCount.propTypes = {
  count: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onClick: PropTypes.func.isRequired,
  className: PropTypes.string,
};
